<template>
  <div>
    <v-data-table
      :headers="parsedHeaders()"
      :items="items"
      :loading="localLoading"
      disable-pagination
      disable-filtering
      disable-sort
      hide-default-footer
      hide-default-header
      dense
      class="my-2"
    >
      <template v-if="type == 'bed'" v-slot:item="{ item }">
        <tr @click="redirectBed(item.bedId)">
          <td>
            <p class="caption">{{ item.bed }}</p>
          </td>
          <td class="nowrap">
            <p class="caption">{{ item.dueDate }}</p>
          </td>
        </tr>
      </template>
      <template v-else-if="type == 'reservation'" v-slot:item="{ item }">
        <tr>
          <td>
            <p class="caption">{{ item.reservationId }}</p>
          </td>
          <td class="nowrap">
            <p class="caption">{{ item.moveInDate }}</p>
          </td>
        </tr>
      </template>
      <template v-else-if="type == 'pdc'" v-slot:item="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <tr @click="redirectPdcs" v-on="on">
              <td style="max-width: 100px">
                <p class="caption text-overflow">{{ item.tenantName }}</p>
              </td>
              <td class="nowrap">
                <p class="caption">{{ item.dueDate }}</p>
              </td>
            </tr>
          </template>
          {{ item.tenantName }}
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Hashids from 'hashids'
const hashids = new Hashids()

export default {
  props: ['loading', 'items', 'type'],
  data() {
    return {
      headers: [
        { text: 'Bed', value: 'bed' },
        { text: 'Due Date', value: 'dueDate' }
      ],
      reservationHeaders: [
        { text: 'ID', value: 'reservationId' },
        { text: 'Move In', value: 'moveInDate' }
      ],
      localLoading: this.loading
    }
  },
  methods: {
    redirectBed(bedId) {
      // prevent multiple clicks
      if (!this.localLoading) {
        this.localLoading = true
        this.$router.push('bed/' + hashids.encode(bedId))
      }
    },
    parsedHeaders() {
      if (this.type === 'bed') {
        return this.headers
      }
      if (this.type === 'reservation') {
        return this.reservationHeaders
      }
    },
    redirectPdcs() {
      this.$router.push('/pdcs')
    }
  }
}
</script>

<style scoped>
table tbody tr td {
  border: none !important;
  border-bottom: none !important;
}
p {
  margin-bottom: 0;
}
.v-data-table {
  background-color: #ffffff;
}

.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nowrap {
  white-space: nowrap;
}
</style>
